import { gql } from 'graphql.macro';

export const createActionTemplate = gql`
    mutation createAction(
        $actionCode: String!
        $internalCode: String
        $description: String!
        $category: String!
        $denthubRestorationType: RestorationType!
        $vat: Float!
        $groups: [MongoDbObjectId]
        $materialMacros: [MongoDbObjectId]
        $productionPlanningTemplate: TenderedProductionTemplateRefInput
        $productionValueTemplate: TenderedProductionTemplateRefInput
        $productionDeductionValue: Int
    ) {
        createAction(
            actionCode: $actionCode
            internalCode: $internalCode
            description: $description
            category: $category
            denthubRestorationType: $denthubRestorationType
            vat: $vat
            groups: $groups
            materialMacros: $materialMacros
            productionPlanningTemplate: $productionPlanningTemplate
            productionValueTemplate: $productionValueTemplate
            productionDeductionValue: $productionDeductionValue
        ) {
            _id
            actionCode
            internalCode
            description
            category
            denthubRestorationType
            vat
            addedDate
            inactive
            inactivatedDate
            groups {
                _id
                name
            }
            materialMacros {
                _id
                name
            }
            productionPlanningTemplate {
                digitalTemplateId
                physicalTemplateId
            }
            productionValueTemplate {
                digitalTemplateId
                physicalTemplateId
            }
            productionDeductionValue
        }
    }
`;

export const modifyActionTemplate = gql`
    mutation modifyAction(
        $_id: String!
        $actionCode: String!
        $internalCode: String
        $description: String!
        $denthubRestorationType: RestorationType!
        $category: String!
        $vat: Float!
        $inactive: Boolean
        $groups: [MongoDbObjectId]
        $materialMacros: [MongoDbObjectId]
        $productionPlanningTemplate: TenderedProductionTemplateRefInput
        $productionValueTemplate: TenderedProductionTemplateRefInput
        $productionDeductionValue: Int
    ) {
        modifyAction(
            _id: $_id
            actionCode: $actionCode
            internalCode: $internalCode
            description: $description
            denthubRestorationType: $denthubRestorationType
            category: $category
            vat: $vat
            inactive: $inactive
            groups: $groups
            materialMacros: $materialMacros
            productionPlanningTemplate: $productionPlanningTemplate
            productionValueTemplate: $productionValueTemplate
            productionDeductionValue: $productionDeductionValue
        ) {
            _id
            actionCode
            internalCode
            description
            category
            denthubRestorationType
            vat
            addedDate
            inactive
            inactivatedDate
            groups {
                _id
                name
            }
            materialMacros {
                _id
                name
            }
            productionPlanningTemplate {
                digitalTemplateId
                physicalTemplateId
            }
            productionValueTemplate {
                digitalTemplateId
                physicalTemplateId
            }
            productionDeductionValue
        }
    }
`;

export const createActionPriceListTemplate = gql`
    mutation createActionPriceList($actionPriceListName: String!, $currency: String!) {
        createActionPriceList(actionPriceListName: $actionPriceListName, currency: $currency) {
            _id
            actionPriceListName
            currency
            isStandardPriceList
            actions {
                _id
                actionCode
                description
                category
                vat
                addedDate
                inactive
                inactivatedDate
            }
        }
    }
`;

export const modifyActionPriceListTemplate = gql`
    mutation modifyActionPriceList($_id: String!, $actionPriceListName: String!) {
        modifyActionPriceList(_id: $_id, actionPriceListName: $actionPriceListName) {
            _id
            actionPriceListName
            currency
            isStandardPriceList
            actions {
                _id
                actionCode
                description
                category
                vat
                addedDate
                inactive
                inactivatedDate
            }
        }
    }
`;

export const deleteActionPriceListTemplate = gql`
    mutation deleteActionPriceList($priceListId: String!) {
        deleteActionPriceList(priceListId: $priceListId)
    }
`;

export const addDefaultActionPriceListTemplate = gql`
    mutation addDefaultActionPriceList($priceListId: String!) {
        addDefaultActionPriceList(priceListId: $priceListId) {
            _id
            actionPriceListName
            currency
            isStandardPriceList
            actions {
                _id
                actionCode
                description
                category
                vat
                addedDate
                inactive
                inactivatedDate
            }
        }
    }
`;

export const addActionToPriceListTemplate = gql`
    mutation addActionToPriceList(
        $priceListId: String!
        $actionId: String!
        $basePrice: Float!
        $tiotandvardPrice: Float
    ) {
        addActionToPriceList(
            priceListId: $priceListId
            actionId: $actionId
            basePrice: $basePrice
            tiotandvardPrice: $tiotandvardPrice
        ) {
            _id
            actionPriceListName
            currency
            isStandardPriceList
            actions {
                _id
                actionCode
                description
                basePrice
                tiotandvardPrice
            }
        }
    }
`;

export const editActionPriceListRowTemplate = gql`
    mutation editActionPriceListRow(
        $priceListId: String!
        $actionId: String!
        $basePrice: Float!
        $tiotandvardPrice: Float
    ) {
        editActionPriceListRow(
            priceListId: $priceListId
            actionId: $actionId
            basePrice: $basePrice
            tiotandvardPrice: $tiotandvardPrice
        ) {
            _id
            actionPriceListName
            currency
            isStandardPriceList
            actions {
                _id
                actionCode
                description
                basePrice
                tiotandvardPrice
            }
        }
    }
`;

export const deleteActionPriceListRowTemplate = gql`
    mutation deleteActionPriceListRow($priceListId: String!, $actionId: String!) {
        deleteActionPriceListRow(priceListId: $priceListId, actionId: $actionId) {
            _id
            actionPriceListName
            currency
            isStandardPriceList
            actions {
                _id
                actionCode
                description
                category
                vat
                basePrice
                addedDate
                inactive
                inactivatedDate
            }
        }
    }
`;

export const createCategoryTemplate = gql`
    mutation createCategory($name: String!) {
        createCategory(name: $name) {
            _id
            name
        }
    }
`;

export const modifyCategoryTemplate = gql`
    mutation modifyCategory($_id: String!, $name: String!) {
        modifyCategory(_id: $_id, name: $name) {
            _id
            name
        }
    }
`;

export const createGroupTemplate = gql`
    mutation createGroup($name: String!) {
        createGroup(name: $name) {
            _id
            name
        }
    }
`;

export const modifyGroupTemplate = gql`
    mutation modifyGroup($_id: MongoDbObjectId!, $name: String!) {
        modifyGroup(_id: $_id, name: $name) {
            _id
            name
        }
    }
`;

export const deleteGroupTemplate = gql`
    mutation deleteGroup($groupId: MongoDbObjectId!) {
        deleteGroup(groupId: $groupId)
    }
`;

export const updateTenderedActionTemplate = gql`
    mutation updateTenderedAction(
        $customerId: MongoDbObjectId!
        $actionId: MongoDbObjectId!
        $internalCode: String
        $productionPlanningTemplate: TenderedProductionTemplateRefInput
        $productionValueTemplate: TenderedProductionTemplateRefInput
        $productionDeductionValue: Int
        $materialMacros: [MongoDbObjectId]
    ) {
        updateTenderedAction(
            customerId: $customerId
            actionId: $actionId
            internalCode: $internalCode
            productionPlanningTemplate: $productionPlanningTemplate
            productionValueTemplate: $productionValueTemplate
            productionDeductionValue: $productionDeductionValue
            materialMacros: $materialMacros
        )
    }
`;
